import React, { useEffect, useState } from "react";
import "../../assets/styles/VisitorStatisticsStyle/SalesReportStyle/SalesReportState.css";
import { convertObjToArray } from "../../helper/Helper";
import axios from "../../js/Axios/Axios";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
export default function VisitorStatisticsMostState() {
  const [data, setData] = useState([]);
  useEffect(() => {
    axios
      .get("/Province/report")
      .then((res) => {
        console.log(res);
        setData(convertObjToArray(res.data));
        console.log(data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  return (
    <div className="sales-report-most-state">
      <div className="sales-report-most-state-title-box">
        <p>براساس استان</p>
      </div>
      <div className="sales-report-most-state-box">
        <div className="sales-report-most-state-top-bar">
          <div className="sales-report-most-state-top-bar-hashtag">
            <p>استان</p>
          </div>
          <div className="sales-report-most-state-top-bar-state">
            <p>تعداد سفارش</p>
          </div>
          <div className="sales-report-most-state-top-bar-count">
            <p>مجموع مبالغ</p>
          </div>
        </div>
        <SimpleBar
          forceVisible="y"
          className="sales-report-most-state-item-box"
        >
          {data.map((item, index) => {
            return (
              <div key={index} className="sales-report-most-state-item-1">
                <div className="sales-report-most-state-item-hashtag">
                  <p>{item.key}</p>
                </div>
                <div className="sales-report-most-state-item-state">
                  <p>{item.value.order_count}</p>
                </div>
                <div className="sales-report-most-state-item-number">
                  <p>{item.value.province_total_price}</p>
                </div>
              </div>
            );
          })}
        </SimpleBar>
      </div>
    </div>
  );
}
